<template>
  <div class="loading-img text-center">
    <div v-show="reload">
      <p>Taking too long? Please reload</p>
      <button
        class="btn btn-primary"
        style="padding: 0.4rem"
        onclick="location.reload()"
      >
        Reload
      </button>
    </div>
    <span>Loading...</span>
    <img src="./../assets/images/loading.svg" alt="Loading..." />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading-img {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 2rem;
  flex-direction: column-reverse;
}

p {
  font-size: 18px;
  margin-top: 1rem;
}

span {
  margin-top: -1rem;
  position: relative;
}

img {
  width: 12rem;
}
</style>

<script>
export default {
  data() {
    return {
      reload: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.reload = true;
    }, 20000);
  },
};
</script>
